import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Col, Row, Form, Button } from "@themesberg/react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import JoditEditor from "jodit-react";
import { BaseUrl } from "../Routes/BaseUrl";
import slugify from "slugify";

export const BlogEditComponent = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const editor = useRef(null);
  const [loading, setLoading] = useState(false);
  const [addCat, setAddCat] = useState(false);
  const [categories, setCategories] = useState([]);

  const {
    control,
    handleSubmit,
    setValue,
    register,
    watch,
    formState: { errors },
    reset,
    getValues,
  } = useForm({
    defaultValues: {
      title: "",
      category: "",
      subCategory: "",
      content: "",
      status: true
    }
  });

  const fetchCategory = async () => {
    const token = localStorage.getItem("token");
      try {
      const response = await fetch(`${BaseUrl.trim()}/admin/blog/all-category`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const json = await response.json();
      console.log("this is the data in json = ", json);
      // setCategories([...new Set(json?.data?.map((item) => item?.category))]);
      setCategories(json?.data);
      console.log(json.data);
    } catch (e) {
      console.error("Error fetching categories:", e);
    }
  };

  const fetchBlogData = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.put(
        (BaseUrl.trim() + `/admin/blog/getSingle`), { id: id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log('response:', response.data.data);
      const blogData = response?.data?.data;

      // Set form values using react-hook-form's reset
      reset({
        title: blogData?.title || "",
        category: blogData?.category?._id || "",
        subCategory: blogData?.subCategory || "",
        content: blogData?.content || "",
        status: blogData?.status
      });
    } catch (error) {
      console.error("Error fetching blog data:", error);
    }
  };

  useEffect(() => {
    fetchBlogData();
    fetchCategory();
    console.log("this is the data in useEffect = ", getValues());
  }, []);

  const onSubmit = async (data) => {
    setLoading(true);
    const token = localStorage.getItem("token");
    data.slug = slugify(data.title, { lower: true, strict: true, remove: /[^a-zA-Z0-9\s]/g });
    console.log("this is the data in onSubmit = ", data);

    try {
      const response = await axios.put(
        `${BaseUrl.trim()}/admin/blog/update/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 200) {
        toast.success(response.data.message);
        console.log("Blog updated successfully:", response.data);
      } else {
        console.error("Unexpected response status:", response.status);
      }
    } catch (error) {
      if (error.response) {
        toast.error(`Error updating blog: ${error.response?.data?.message || error.message}`);
        console.error("Error updating blog:", error.response.data);
      } else {
        toast.error(`Error updating blog: ${error.message}`);
        console.error("Error updating blog:", error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const categoryChangeHandler = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue === "addNew") {
      setValue("category", "");
      setAddCat(true); 
    } else {
      setValue("category", selectedValue); 
      setAddCat(false);
    }
  }

  return (
    <>
      <h5 className="mb-4">Edit Blog</h5>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Title</Form.Label>
              <Form.Control
                {...register("title", { required: "Title is required" })}
                placeholder="Enter blog title"
              />
              {errors.title && <p className="text-danger">{errors.title.message}</p>}
            </Form.Group>
          </Col>
          <Col md={6}>
            {!addCat ? (
              <Form.Group>
                <Form.Label>Category</Form.Label>
                <Form.Select {...register("category", { required: "Category is required" })}
                  value={watch("category")}
                  onChange={categoryChangeHandler}>
                  <option value="">Select category</option>
                  {categories.map((cat) => (
                    <option key={cat._id} value={cat.category} >
                      {cat.category}
                    </option>
                  ))}
                  <option value="addNew">Add Category</option>
                </Form.Select>
                {errors.category && <p className="text-danger">{errors.category.message}</p>}
              </Form.Group>
            ) : (
              <Form.Group>
                <Form.Label>New Category</Form.Label>
                <Form.Control {...register("category", { required: "New category is required" })} placeholder="Enter new category" />
                <Button variant="link" onClick={() => setAddCat(false)}>Cancel</Button>
              </Form.Group>
            )}
          </Col>
        </Row>
        <Row>
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>SubCategory</Form.Label>
              <Form.Control
                {...register("subCategory")}
                placeholder="Enter subcategory (Optional)"
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mb-3">
            <Form.Group>
              <Form.Label>Content</Form.Label>
              <Controller
                name="content"
                control={control}
                rules={{ required: "Content is required" }}
                render={({ field }) => (
                  <JoditEditor
                    ref={editor}
                    value={field.value}
                    onChange={(newContent) => field.onChange(newContent)}
                  />
                )}
              />
              {errors.content && <p className="text-danger">{errors.content.message}</p>}
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-3">
          <Form.Label>Publication Status</Form.Label>
          <div className="d-flex gap-4">
            <Form.Check
              type="radio"
              id="status-publish"
              label="Publish"
              value={true}
              {...register("status")}
              defaultChecked={watch("status") === true}
            />
            <Form.Check
              type="radio"
              id="status-draft"
              label="Draft"
              value={false}
              {...register("status")}
              defaultChecked={watch("status") === false}
            />
          </div>
        </Form.Group>

        <div className="mt-3">
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </Button>
        </div>
      </Form>
    </>
  );
};
